<div
  class="relative transition-opacity duration-500"
  [ngClass]="{ 'opacity-0 pointer-events-none': is3dOpen() }">
  <div
    class="top-0 right-0 -z-10 absolute rounded-full w-full h-full"
    [ngClass]="[
      showUpgrades ? 'scale-100' : 'scale-0',
      upgradesVars.acquiredUpgrade ? 'bg-success' : 'bg-red',
      upgradesVars.reachingUpgrade || upgradesVars.acquiredUpgrade
        ? 'animate-ping'
        : '',
    ]"></div>

  <button
    (click)="toggleBenefits()"
    [ngClass]="[
      showUpgrades ? 'scale-100' : 'scale-0',
      upgradesVars.acquiredUpgrade ? 'bg-success' : 'bg-red',
    ]"
    class="z-30 relative flex justify-center items-center bg-red shadow-red hover:shadow-lg rounded-full w-12 h-12 hover:scale-95 transition-all ease-in-out">
    <img src="/assets/img/box-gift-icon.svg" alt="Box gift icon" />
  </button>

  @if (upgradesVars.acquiredUpgrades.length > 0) {
    <div
      [class]="showUpgrades ? 'scale-100' : 'scale-0'"
      class="top-0 -right-1 z-30 absolute flex justify-center items-center bg-white rounded-full w-6 h-6">
      <span class="text-red text-xs font-bold">
        {{ upgradesVars.acquiredUpgrades.length }}
      </span>
    </div>
  }

  <div
    class="top-0 right-4 z-20 absolute flex justify-end items-center w-144 h-full overflow-hidden"
    [ngClass]="[
      upgradesVars.reachingUpgrade || upgradesVars.acquiredUpgrade
        ? 'pointer-events-auto '
        : 'pointer-events-none',
      showUpgrades ? 'block' : 'hidden',
    ]">
    <div
      class="temporal-line-container"
      [class]="upgradesVars.reachingUpgrade ? 'show' : 'hide'">
      @if (upgradesVars.reachingUpgrade) {
        <p class="mr-5 text-main text-xs">
          Purchase
          <span class="font-bold">
            {{ upgradesVars.reachingUpgrade.goal }} tickets
          </span>
          and receive
          <span class="font-bold">
            {{ upgradesVars.reachingUpgrade.name }}
          </span>
        </p>
      }
    </div>

    <div
      class="temporal-line-container"
      [class]="upgradesVars.acquiredUpgrade ? 'show' : 'hide'">
      @if (upgradesVars.acquiredUpgrade) {
        <p class="mr-5 text-main text-xs">
          You unlocked the
          <span class="font-bold">
            {{ upgradesVars.acquiredUpgrade.name }}
          </span>
          by purchasing
          <span class="font-bold">
            {{ upgradesVars.acquiredUpgrade.goal }} tickets
          </span>
        </p>
      }
    </div>
  </div>

  <div
    #benefitsContainer
    class="block top-5 right-5 z-10 absolute bg-white rounded-lg w-64 h-auto max-h-80 overflow-hidden origin-top-right"
    style="transform: scale(0)">
    <div class="p-6">
      <h4 class="mb-2 text-main text-sm">
        {{ templateVars.text }}
      </h4>
      <hr />

      <div class="mt-3">
        <ul class="flex flex-col gap-y-3 mb-2">
          @for (upgrade of upgradesVars.acquiredUpgrades; track upgrade.id) {
            <li class="flex items-center gap-x-2 cursor-default">
              <div class="w-1/6">
                <span
                  class="block mx-auto border border-gray-400 rounded-full w-[16px] h-[16px]">
                  <img
                    src="/assets/img/check-circle-fill-icon.svg"
                    alt="Check circle fill icon" />
                </span>
              </div>
              <div class="w-5/6">
                <p class="text-main">
                  You unlocked the
                  <span>
                    {{ upgrade.name }}
                  </span>
                  by purchasing
                  <span> {{ upgrade.goal }} tickets </span>
                </p>
              </div>
            </li>
          }
        </ul>

        <ul class="flex flex-col gap-y-3">
          @for (upgrade of upgradesVars.availableUpgrades; track upgrade.id) {
            <li class="flex items-center gap-x-2 cursor-default">
              <div class="w-1/6">
                <span
                  class="block bg-transparent mx-auto border border-gray-400 rounded-full w-[16px] h-[16px]"></span>
              </div>
              <div class="w-5/6">
                <p class="text-main">
                  Purchase
                  <span> {{ upgrade.goal }} tickets </span>
                  and receive
                  <span>
                    {{ upgrade.name }}
                  </span>
                </p>
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
</div>
